// From https://github.com/react-hook-form/resolvers/blob/1bfc6abbe99677fe574f0919f84b385cc4e686f4/zod/src/zod.ts

import { FieldError } from 'react-hook-form';
import { ZodIssue } from 'zod';

export function parseZodError(zodErrors: ZodIssue[]) {
  const errors: Record<string, FieldError> = {};
  for (; zodErrors.length; ) {
    const error = zodErrors[0];
    if (!error) continue;

    const { code, message, path } = error;
    const _path = path.join('.');

    if (!errors[_path]) {
      if ('unionErrors' in error) {
        const unionError = error.unionErrors[0]?.errors[0];
        if (!unionError) continue;

        errors[_path] = {
          message: unionError.message,
          type: unionError.code,
        };
      } else {
        errors[_path] = { message, type: code };
      }
    }

    if ('unionErrors' in error) {
      error.unionErrors.forEach((unionError) =>
        unionError.errors.forEach((e) => zodErrors.push(e)),
      );
    }

    zodErrors.shift();
  }

  return errors;
}
